import { ENTER_KEY, TAB_KEY } from '../../../const/keyNames';
export const handleShowHideKeyDown = (event, setTypeValue, typeValue, clickFocus) => {
    if (event.key === TAB_KEY || (event.shiftKey && event.key === TAB_KEY))
        return;
    if (event.shiftKey)
        event.preventDefault();
    if (event.key === ENTER_KEY) {
        event.preventDefault();
        setTypeValue(typeValue === 'password' ? 'text' : 'password');
        clickFocus();
    }
};
export const handleShowHideMouseDown = (event, clickFocus) => {
    event.stopPropagation();
    event.preventDefault();
    clickFocus();
};
export const handleShowHideMouseUp = (setTypeValue, typeValue) => {
    setTypeValue(typeValue === 'password' ? 'text' : 'password');
};
export const handleOnBlur = ({ event, onBlur, setTelPlaceholder, isInputTypeTel }) => {
    if (isInputTypeTel) {
        setTelPlaceholder('');
    }
    if (typeof onBlur === 'function') {
        onBlur(event);
    }
};
export const handleOnFocus = ({ event, setTelPlaceholder, isInputTypeTel, onFocus }) => {
    if (isInputTypeTel) {
        setTelPlaceholder('(___) ___ - ___');
    }
    event.preventDefault();
    if (onFocus) {
        onFocus(event);
    }
};
export const formatTelephoneNumber = ({ inputValue }) => {
    const formattedValue = inputValue.replace(/\D/g, '').substring(0, 10);
    if (formattedValue.length > 6) {
        return formattedValue.replace(/(\d{3})(\d{3})(\d{1,3})/, `($1) $2 - $3`);
    }
    if (formattedValue.length > 3) {
        return formattedValue.replace(/(\d{3})(\d{1,3})/, `($1) $2`);
    }
    return inputValue;
};
export const reFormatTelephoneNumber = ({ event, onChange }) => {
    const inputReference = event.target;
    const reFormattedValue = inputReference.value
        .replace(/\D/g, '')
        .substring(0, 10);
    inputReference.value = reFormattedValue;
    onChange(event);
};
const handleEventChange = ({ event, isInputTypeTel, onChange }) => {
    if (isInputTypeTel) {
        reFormatTelephoneNumber({ event, onChange });
    }
    else {
        onChange(event);
    }
};
export const handleOnChange = ({ event, matchPattern, onChange, isInputTypeTel }) => {
    if (!matchPattern) {
        handleEventChange({ event, isInputTypeTel, onChange });
        return;
    }
    const pattern = new RegExp(matchPattern);
    if (pattern.test(event.target.value)) {
        handleEventChange({ event, isInputTypeTel, onChange });
    }
};
